import React, { useContext } from 'react'
import { Spin } from 'antd'
// import TerminalRt from 'terminal-in-react'
import style from './styles/create-function.module.css'

// icons
import { ReactComponent as BottomIcon } from '../../../../assets/svg/MarketplaceFunctions/log_bottom.svg'
import { ReactComponent as RightIcon } from '../../../../assets/svg/MarketplaceFunctions/Log_Right-1.svg'
import { logs, useCreateFunction } from './CreateFunctionContext'

interface ITerminal {
  terminalRef: any
  editorRef: any
  setEditorSplitView: (splitView: 'horizontal' | 'vertical') => void
  isExecuting: boolean
  editorSplitView: 'horizontal' | 'vertical'
}

export const Terminal: React.FC<ITerminal> = (props) => {
  const {
    setEditorSplitView,
    editorSplitView,
    terminalRef,
    isExecuting,
    editorRef
  } = props
  const { state } = useCreateFunction()
  const logs = state.logs

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Header
        editorSplitView={editorSplitView}
        setEditorSplitView={setEditorSplitView}
        editorRef={editorRef}
        terminalRef={terminalRef}
      />
      <Spin tip="Executing..." spinning={isExecuting}>
        <div style={{ padding: "10px" }}>
          <span style={{ color: "green" }}>$</span> {typeof logs === "object" ? JSON.stringify(logs, null, 2) : logs}
        </div>
      </Spin>
    </div>
  )
}

interface IHeader {
  editorSplitView: 'horizontal' | 'vertical'
  setEditorSplitView: (splitView: 'horizontal' | 'vertical') => void
  editorRef: any,
  terminalRef: any,
}

const Header: React.FC<IHeader> = (props) => {
  const { editorSplitView, setEditorSplitView, editorRef } = props
  const { dispatch } = useCreateFunction()

  const clearTerminal = () => {
    dispatch(logs(""))
  }

  const handleToggleSplit = () => {
    const source = editorRef.current.getValue()
    const view = editorSplitView === 'horizontal' ? 'vertical' : 'horizontal'
    setEditorSplitView(view)

    // without using setTimeout, it fails to update the content
    // in the editor
    setTimeout(() => {
      editorRef.current.setValue(source)
    }, 0)
  }

  return (
    <div
      className={style.tabPaneHeader}
      style={{ padding: '12px 36px 12px 16px', borderBottom: "1px solid #a9a8a870", margin: "2px" }}
    >
      <p style={{ color: '#000', fontSize: 16 }}>Console</p>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button onClick={() => clearTerminal()} style={{ width: "44px", cursor: "pointer", outline: "none", height: "24px", backgroundColor: "#DBDBDB80", borderRadius: 3, color: "#052f35 ", border: '1px solid #DBDBDB', fontStyle: "normal", fontWeight: 600, fontSize: "10px", lineHeight: "13px", marginRight: "7px" }}>
          Clear
        </button>
        <div onClick={handleToggleSplit} style={{ cursor: 'pointer' }}>
          {editorSplitView === 'vertical' ? <BottomIcon /> : <RightIcon />}
        </div>
      </div>
    </div>
  )
}
